import { connect } from 'react-redux';
import {
    getLoggedUser,
    getWaitingList,
    shouldShowUpgradePlanButton,
    shouldShowBillingCenter,
} from './logged-user.state';
import { UserProfile } from './logged-user.types';

export interface WithLoggedUserProps{
    loggedUser: UserProfile;
}

export const withLoggedUser = connect(
    state => ({
        loggedUser: getLoggedUser(state),
        waitingList: getWaitingList(state),
        shouldShowUpgradePlanButton: shouldShowUpgradePlanButton(state),
        shouldShowBillingCenter: shouldShowBillingCenter(state),
    }),
);
